module.exports = __webpack_public_path__ + "static/media/CommunicationsStyles.e5cb6198.png";